import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {TreeListComponent} from './tree-list.component';

const routes: Routes = [
  {path: 'treelist', component: TreeListComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class TreeListRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-list/tree-list-routing.module.ts